import { createRouter, createWebHashHistory } from "vue-router";
import main from "../views/main.vue";
import { ElNotification } from "element-plus";

const routes = [
	{
		path: "/",
		name: "main",
		component: main,
		children: [
			{
				path: "/",
				name: "home",
				component: () => import("../views/home/home.vue"),
			},
			{
				path: "/family_browse",
				name: "family_browse",
				component: () => import("../views/project/family_browse.vue"),
			},
			{
				path: "/family_manage",
				name: "family_manage",
				component: () => import("../views/project/family_manage.vue"),
			},
			{
				path: "/product_browse",
				name: "product_browse",
				component: () => import("../views/project/product_browse.vue"),
			},
			{
				path: "/product_manage",
				name: "product_manage",
				component: () => import("../views/project/product_manage.vue"),
			},
			{
				path: "/project_browse",
				name: "project_browse",
				component: () => import("../views/project/project_browse.vue"),
			},
			{
				path: "/project_manage",
				name: "project_manage",
				component: () => import("../views/project/project_manage.vue"),
			},
			{
				path: "/project_assign",
				name: "project_assign",
				component: () => import("../views/project/project_assign.vue"),
			},
			{
				path: "/project_module",
				name: "project_module",
				component: () => import("../views/project/project_module.vue"),
			},
			{
				path: "/version_browse",
				name: "version_browse",
				component: () => import("../views/project/version_browse.vue"),
			},
			{
				path: "/version_manage",
				name: "version_manage",
				component: () => import("../views/project/version_manage.vue"),
			},
			{
				path: "/version_change",
				name: "version_change",
				component: () => import("../views/project/version_change.vue"),
			},
			{
				path: "/config_right",
				name: "config_right",
				component: () => import("../views/project/config_right.vue"),
			},
			{
				path: "/qxbmlb",
				name: "qxbmlb",
				component: () => import("../views/pzx/qxbmlb.vue"),
			},
			{
				path: "/qxyhlb",
				name: "qxyhlb",
				component: () => import("../views/pzx/qxyhlb.vue"),
			},
			{
				path: "/dict_family_status",
				name: "dict_family_status",
				component: () => import("../views/project/dict_family_status.vue"),
			},
			{
				path: "/dict_product_status",
				name: "dict_product_status",
				component: () => import("../views/project/dict_product_status.vue"),
			},
			{
				path: "/dict_project_status",
				name: "dict_project_status",
				component: () => import("../views/project/dict_project_status.vue"),
			},
			{
				path: "/dict_version_status",
				name: "dict_version_status",
				component: () => import("../views/project/dict_version_status.vue"),
			},
		],
	},
	{
		path: "/login",
		name: "login",
		component: () => import("../views/login/login.vue"),
	},
	{
		path: "/404",
		name: "404",
		component: () => import("@/views/noPage/404.vue"),
	},
	{
		path: "/linkLog",
		name: "linkLog",
		component: () => import("@/views/noPage/linkLog.vue"),
	},
	{
		path: "/:catchAll(.*)",
		redirect: "/404",
	},
];

const router = createRouter({
	history: createWebHashHistory(),
	routes,
});

const whiteList = ["login", "linkLog"];
router.beforeEach((to, from, next) => {
	if (localStorage.getItem("token")) {
		next();
	} else {
		if (whiteList.indexOf(to.name) !== -1) {
			next();
		} else {
			ElNotification({
				title: "系统提示",
				message: "未登录，请登录",
				type: "error",
				duration: 3000,
			});
			next({ path: "/login" });
		}
	}
});
export default router;
